import { logger } from '@app/utils/logger'
import { ToastOptions } from './ToastProvider'

let toastFn: ((opts: ToastOptions) => void) | null = null
let handleCloseFn: () => void

export const setToastFn = (fn: (opts: ToastOptions) => void) => {
  toastFn = fn
}

export const setHandleCloseFn = (fn: () => void) => {
  handleCloseFn = fn
}

export const toast = (opts: ToastOptions) => {
  if (!toastFn) {
    logger.warn('ToastProvider not mounted')
    return
  }
  toastFn(opts)
}

export const handleClose = () => {
  if (!handleCloseFn) {
    logger.warn('ToastProvider not mounted')
    return
  }

  handleCloseFn()
}
